import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useCupon } from "../../../../context/CuponContext";

export default function DetalleCupon() {
    const { cuponSeleccionado, modalOpenDetalleCupon, handleOpenDetalleCupon } = useCupon();

    return (
        <MeditocModal
            size="small"
            title="Detalle de cupón"
            open={modalOpenDetalleCupon}
            setopen={handleOpenDetalleCupon}
            okmessage="Cerrar detalle"
            hidecancel
        >
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="ID de cupón" value={cuponSeleccionado.fiIdCupon} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Código de cupón:" value={cuponSeleccionado.fsCodigo} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Descripción:" value={cuponSeleccionado.fsDescripcion} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Tipo de cupón:" value={cuponSeleccionado.fsDescripcionCategoria} />
                </Grid>
                {cuponSeleccionado.sMontoDescuento && (
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField label="Monto de descuento:" value={cuponSeleccionado.sMontoDescuento} />
                    </Grid>
                )}
                {cuponSeleccionado.sPorcentajeDescuento && (
                    <Grid item sm={6} xs={12}>
                        <MeditocInfoField
                            label="Porcentaje de descuento:"
                            value={cuponSeleccionado.sPorcentajeDescuento}
                        />
                    </Grid>
                )}
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Total de cupones:" value={cuponSeleccionado.fiTotalLanzamiento} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Total canjeado:" value={cuponSeleccionado.fiTotalCanjeado} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Fecha de creación:" value={cuponSeleccionado.sFechaCreacion} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Fecha de vencimiento:" value={cuponSeleccionado.sFechaVencimiento} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
